import axios from 'axios';

// Shared axios configuration. Import this module once, before any request is made.
axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
